/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExperienceLevelResource } from './';
import {
    ExperienceLevelResourceFromJSON,
    ExperienceLevelResourceFromJSONTyped,
    ExperienceLevelResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateExperienceLevelRequest
 */
export interface UpdateExperienceLevelRequest {
    /**
     * 
     * @type {ExperienceLevelResource}
     * @memberof UpdateExperienceLevelRequest
     */
    experienceLevel: ExperienceLevelResource;
}

/**
 * Check if a given object implements the UpdateExperienceLevelRequest interface.
 */
export function instanceOfUpdateExperienceLevelRequest(value: object): value is UpdateExperienceLevelRequest {
    if (!('experienceLevel' in value) || value['experienceLevel'] === undefined) return false;
    return true;
}

export function UpdateExperienceLevelRequestFromJSON(json: any): UpdateExperienceLevelRequest {
    return UpdateExperienceLevelRequestFromJSONTyped(json, false);
}

export function UpdateExperienceLevelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateExperienceLevelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'experienceLevel': ExperienceLevelResourceFromJSON(json['experienceLevel']),
    };
}

export function UpdateExperienceLevelRequestToJSON(value?: UpdateExperienceLevelRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'experienceLevel': ExperienceLevelResourceToJSON(value['experienceLevel']),
    };
}

